

































 
import {Vue} from '../../constants/constants'
import { staticContent } from "../../localisation/detect-lang"


export default  Vue.component('alert-modal', {
     data() {
    return {
            staticContent
    };
  },
 computed:{
   bindConditionalClasses(){
     return this.$root.bindConditionalClasses;
    },
   alert(){
     return this.$store.state.alert
   },
  
 },
  methods:{
    modalToggler(modal, method) {
      this.$root.modalToggler(modal, method);
    },
    handleClose(){
      this.$root.alertClosed.redirect ?
       (window.location.href = this.$root.alertClosed.URL):
      this.modalToggler('alert-modal','hide')
    }
  }
})
